// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorGroupSupervisoryStatus {
  UpPeak = 0,
  DownPeak = 1,
  LobbyPeak = 2,
  HeavyTraffic = 3,
  Fire = 4,
  EmergencyPower = 5,
  PH1 = 6,
  HcPower = 7,
  HcComm = 8,
  Sec = 9,
  Balanced = 10,
  AutoBalance = 11,
  AutoLobby = 12,
  AutoDemandUp = 13,
  AutoDemandDown = 14,
  Normal = 15,
  Epd = 16,
  Evacuation = 17,
  Standby = 18,
  HallButtonPower = 19,
  Earthquake = 20,
  AlternateFire = 21,
  MainFire = 22,
  BlockOperation = 23,
  CommunicationProblem = 24,
  DownPeakTraffic = 25,
  EmergencyPowerEvacuation = 26,
  GroupSwitchOff = 27,
  LockTrip = 28,
  Miconic10 = 29,
  NoonPeakTraffic = 30,
  NormalTraffic = 31,
  StatusNotAvailable = 32,
  TerminalFault = 33,
  TrafficMode = 34,
  UpPeakTraffic = 35,
  VirtualTerminal = 36
}
